@if (isTeamAgentOnly) {
  <div class="team-agent-layout">
    @if (showTeamAgentCompanyPicker) {
      <section class="team-agent-section">
        <h2>Companies</h2>
        @if (teamAgentCompaniesLoading) {
          <div class="empty-message">Loading companies...</div>
        }
        @if (!teamAgentCompaniesLoading && teamAgentCompanies.data.length === 0) {
          <div class="empty-message">No team-agent companies assigned.</div>
        }
        @if (teamAgentCompanies.data.length > 0) {
          <table class="table" mat-table [dataSource]="teamAgentCompanies">
            <ng-container matColumnDef="name">
              <th mat-header-cell *matHeaderCellDef>Company</th>
              <td class="cell" mat-cell *matCellDef="let item">{{item.name}}</td>
            </ng-container>
            <ng-container matColumnDef="domainName">
              <th mat-header-cell *matHeaderCellDef>Domain</th>
              <td class="cell" mat-cell *matCellDef="let item">{{item.domainName || '---'}}</td>
            </ng-container>
            <ng-container matColumnDef="actions" stickyEnd>
              <th mat-header-cell *matHeaderCellDef></th>
              <td class="cell actions-cell" mat-cell *matCellDef="let item">
                <button mat-button color="primary" type="button" (click)="selectTeamAgentCompany(item)">Teams</button>
              </td>
            </ng-container>
            <tr mat-header-row *matHeaderRowDef="teamAgentCompanyColumns"></tr>
            <tr class="listitem" mat-row *matRowDef="let rows; columns: teamAgentCompanyColumns"></tr>
          </table>
        }
      </section>
    }
    <section class="team-agent-section">
      <div class="team-agent-section-header">
        <h2>{{selectedTeamAgentCompany ? selectedTeamAgentCompany.name + ' Teams' : 'Teams'}}</h2>
        @if (selectedTeamAgentCompany) {
          <button
            mat-raised-button
            color="accent"
            type="button"
            (click)="createTeamAgentTeam()">
            <mat-icon>add</mat-icon>
            Create new team
          </button>
        }
      </div>
      @if (!selectedTeamAgentCompany) {
        <div class="empty-message">Select a company to view teams.</div>
      }
      @if (selectedTeamAgentCompany && teamAgentTeamsLoading) {
        <div class="empty-message">Loading teams...</div>
      }
      @if (selectedTeamAgentCompany && !teamAgentTeamsLoading && teamAgentTeams.data.length === 0) {
        <div class="empty-message">No teams found for this company.</div>
      }
      @if (selectedTeamAgentCompany && teamAgentTeams.data.length > 0) {
        <table class="table" mat-table [dataSource]="teamAgentTeams">
          <ng-container matColumnDef="name">
            <th mat-header-cell *matHeaderCellDef>Team</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.name}}</td>
          </ng-container>
          <ng-container matColumnDef="ownerName">
            <th mat-header-cell *matHeaderCellDef>Team Admin</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.ownerName || '---'}}</td>
          </ng-container>
          <ng-container matColumnDef="createdAt">
            <th mat-header-cell *matHeaderCellDef>Created</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.createdAt | date : 'medium'}}</td>
          </ng-container>
          <ng-container matColumnDef="approved">
            <th mat-header-cell *matHeaderCellDef>Approved</th>
            <td class="cell" mat-cell *matCellDef="let item">{{item.approved ? 'Yes' : 'No'}}</td>
          </ng-container>
          <ng-container matColumnDef="actions" stickyEnd>
            <th mat-header-cell *matHeaderCellDef></th>
            <td class="cell actions-cell" mat-cell *matCellDef="let item">
              <button mat-button color="primary" type="button" (click)="loginAsTeamAgent(item)">Log In</button>
            </td>
          </ng-container>
          <tr mat-header-row *matHeaderRowDef="teamAgentTeamColumns"></tr>
          <tr class="listitem" mat-row *matRowDef="let rows; columns: teamAgentTeamColumns"></tr>
        </table>
      }
    </section>
  </div>
} @else {
  <div class="actions">
    <div class="company-tree-actions">
      <button class="exportbutton" mat-raised-button color="accent" (click)="export()"><mat-icon>file_download</mat-icon>Export to CSV</button>
      @if (hasTreeMoveSeries) {
        <button
          class="exportbutton"
          mat-raised-button
          color="primary"
          type="button"
          [disabled]="!canUndoTreeMoveSeries"
          (click)="undoLastTreeMoveSeries()">
          <mat-icon>undo</mat-icon>
          Undo moves
        </button>
      }
    </div>
    <button mat-fab (click)="addCompany()"><mat-icon>add</mat-icon></button>
  </div>
  <br><input class="filterinput" matInput [(ngModel)]="filter" (keyup)="applyFilter($event)" placeholder="Filter by...">
  @if (filter) {
    <button matSuffix mat-icon-button aria-label="Clear" (click)="clearFilter()">
      <mat-icon>close</mat-icon>
    </button>
  }
  <mat-menu #menu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="editCompany(item)">Edit Company</button>
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="setManagers(item)">Roles</button>
      @if (isPayrollAdminCompany(item)) {
        <button
          mat-menu-item
          (click)="togglePayrollTeamPlusDefault(item)"
          [matTooltip]="payrollTeamPlusDefaultHelpText">
          {{ getPayrollTeamPlusDefaultActionLabel(item) }}
        </button>
      }
      @if (item.type === 'employer') {
        <button
          mat-menu-item
          (click)="toggleIncludedPlusPlan(item)"
          [matTooltip]="includedPlusPlanHelpText">
          {{ getIncludedPlusPlanActionLabel(item) }}
        </button>
      }
      @if (isSuperAdmin) {
        <button mat-menu-item [matMenuTriggerFor]="productSettingsMenu" [matMenuTriggerData]="{item: item}">
          Product Settings
        </button>
      }
      <mat-divider></mat-divider>
      <button mat-menu-item (click)="setCompanyParent(item)">Set Parent Company</button>
      <button mat-menu-item (click)="addCompany(item)">Add New Company Here</button>
      <button mat-menu-item (click)="removeCompany(item)">Remove</button>
    </ng-template>
  </mat-menu>
  <mat-menu #productSettingsMenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="setProducts(item)">Available Products</button>
      <button mat-menu-item (click)="setCompanyOffers(item)">Company Offers</button>
      <button mat-menu-item (click)="setProductPlanLevels(item)">Product Plan Levels</button>
      <button mat-menu-item (click)="setProductTilesCategories(item)">Product Tiles Categories</button>
      <button mat-menu-item (click)="setProductPayrollBenefitCategories(item)">Product Payroll Benefit Categories</button>
      @if (isCompanySnackRewardSelectionEnabled) {
        <button mat-menu-item (click)="setSnackRewards(item)">Snack Rewards</button>
      }
      <button mat-menu-item (click)="openGroupProductOnboardingStatuses(item)">Product Approval Status</button>
    </ng-template>
  </mat-menu>
  <mat-menu #teammenu="matMenu">
    <ng-template matMenuContent let-item="item">
      <button mat-menu-item (click)="setTeamEmployer(item)">Set Employer</button>
      <button mat-menu-item (click)="viewTeam(item)">View</button>
    </ng-template>
  </mat-menu>
  <mat-tree [dataSource]="dataSource" [treeControl]="treeControl" class="example-tree" cdkDropListGroup>
    <mat-tree-node
      *matTreeNodeDef="let node"
      matTreeNodeToggle
      cdkDropList
      [cdkDropListData]="node"
      [cdkDropListEnterPredicate]="canDropTreeNode"
      [cdkDropListSortingDisabled]="true"
      (cdkDropListDropped)="dropTreeNode($event)">
      <div class="tree-node-drag-row" cdkDrag [cdkDragData]="node" [cdkDragDisabled]="isTreeMoveBusy">
        <span class="tree-node-placeholder"></span>
        <div class="nodeline">
          <div class="iconline">
            <button
              type="button"
              class="tree-drag-handle"
              mat-icon-button
              cdkDragHandle
              [disabled]="isTreeMoveBusy"
              matTooltip="Drag to move"
              aria-label="Drag to move"
              (click)="$event.stopPropagation()">
              <mat-icon>drag_indicator</mat-icon>
            </button>
            <button
              type="button"
              class="node-link"
              [class.node-link-disabled]="!getNodeRoute(node)"
              [disabled]="!getNodeRoute(node)"
              (click)="navigateToNode(node, $event)">
              @if (node.type !== 'wallit') {
                <mat-icon [matTooltip]="getTooltip(node)">{{getIcon(node)}}</mat-icon>
              }
              @if (node.type === 'wallit') {
                <mat-icon svgIcon="wallit"></mat-icon>
              }
              @if (node.logoUrl) {
                <img [src]="node.logoUrl" class="logourl" (error)="logoError($event)">
              }
              <span>{{node.name}} {{node.type !== 'team' ? '(' + node.children.length + ')' : ''}}</span>
            </button>
            @if (node.partnerDisplays?.length) {
              <span class="partner-list">
                @for (partner of node.partnerDisplays; track partner) {
                  <span class="partner-pill">
                    @if (partner.iconUrl) {
                      <img [src]="partner.iconUrl" class="partner-icon" (error)="logoError($event)">
                    }
                    @if (!partner.iconUrl) {
                      <mat-icon class="partner-fallback-icon">handshake</mat-icon>
                    }
                    <span>{{partner.name}}</span>
                  </span>
                }
              </span>
            }
            @if (hasRoleAssignments(node)) {
              <span
                class="status-badge role-count-badge"
                [matTooltip]="node.roleAssignmentTooltip">
                {{node.roleAssignmentCount}} {{node.roleAssignmentCount === 1 ? 'role' : 'roles'}}
              </span>
            }
            @if (hasPayrollTeamPlusDefault(node)) {
              <span
                class="status-badge plus-plan-badge"
                [matTooltip]="payrollTeamPlusDefaultHelpText">
                Payroll Admin Default: Plus
              </span>
            }
            @if (hasIncludedPlusPlan(node)) {
              <span
                class="status-badge plus-plan-badge"
                [matTooltip]="includedPlusPlanHelpText">
                Plus Included
              </span>
            }
          </div>
          <button mat-button class="cell" [matMenuTriggerFor]="node.type !== 'team' ? menu : teammenu" [matMenuTriggerData]="{item: node}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button>
        </div>
      </div>
    </mat-tree-node>
    <mat-nested-tree-node *matTreeNodeDef="let node; when: hasChild">
      <div
        class="mat-tree-node"
        cdkDropList
        [cdkDropListData]="node"
        [cdkDropListEnterPredicate]="canDropTreeNode"
        [cdkDropListSortingDisabled]="true"
        (cdkDropListDropped)="dropTreeNode($event)">
        <div class="tree-node-drag-row" cdkDrag [cdkDragData]="node" [cdkDragDisabled]="isTreeMoveBusy">
          <button mat-icon-button matTreeNodeToggle
            [attr.aria-label]="'Toggle ' + node.name">
            <mat-icon class="mat-icon-rtl-mirror">
              {{treeControl.isExpanded(node) ? 'expand_more' : 'chevron_right'}}
            </mat-icon>
          </button>
          <div class="nodeline">
            <div class="iconline">
              <button
                type="button"
                class="tree-drag-handle"
                mat-icon-button
                cdkDragHandle
                [disabled]="isTreeMoveBusy"
                matTooltip="Drag to move"
                aria-label="Drag to move"
                (click)="$event.stopPropagation()">
                <mat-icon>drag_indicator</mat-icon>
              </button>
              <button
                type="button"
                class="node-link"
                [class.node-link-disabled]="!getNodeRoute(node)"
                [disabled]="!getNodeRoute(node)"
                (click)="navigateToNode(node, $event)">
                @if (node.type !== 'wallit') {
                  <mat-icon [matTooltip]="getTooltip(node)">{{getIcon(node)}}</mat-icon>
                }
                @if (node.type === 'wallit') {
                  <mat-icon svgIcon="wallit"></mat-icon>
                }
                @if (node.logoUrl) {
                  <img [src]="node.logoUrl" class="logourl" (error)="logoError($event)">
                }
                <span>{{node.name}} {{node.type !== 'team' ? '(' + node.children.length + ')' : ''}}</span>
              </button>
              @if (node.partnerDisplays?.length) {
                <span class="partner-list">
                  @for (partner of node.partnerDisplays; track partner) {
                    <span class="partner-pill">
                      @if (partner.iconUrl) {
                        <img [src]="partner.iconUrl" class="partner-icon" (error)="logoError($event)">
                      }
                      @if (!partner.iconUrl) {
                        <mat-icon class="partner-fallback-icon">handshake</mat-icon>
                      }
                      <span>{{partner.name}}</span>
                    </span>
                  }
                </span>
              }
              @if (hasRoleAssignments(node)) {
                <span
                  class="status-badge role-count-badge"
                  [matTooltip]="node.roleAssignmentTooltip">
                  {{node.roleAssignmentCount}} {{node.roleAssignmentCount === 1 ? 'role' : 'roles'}}
                </span>
              }
              @if (hasPayrollTeamPlusDefault(node)) {
                <span
                  class="status-badge plus-plan-badge"
                  [matTooltip]="payrollTeamPlusDefaultHelpText">
                  Payroll Admin Default: Plus
                </span>
              }
              @if (hasIncludedPlusPlan(node)) {
                <span
                  class="status-badge plus-plan-badge"
                  [matTooltip]="includedPlusPlanHelpText">
                  Plus Included
                </span>
              }
            </div>
            <button mat-button class="cell" [matMenuTriggerFor]="menu" [matMenuTriggerData]="{item: node}"><mat-icon matTooltip="Actions" class="more">more_vert</mat-icon></button>
          </div>
        </div>
      </div>
      <div [class.example-tree-invisible]="!treeControl.isExpanded(node)"
        role="group">
        <ng-container matTreeNodeOutlet></ng-container>
      </div>
    </mat-nested-tree-node>
  </mat-tree>
}
